import React from 'react';
import { Col } from '../layot/Flex';

const MainImage = () => {
    return <Col className="bgImage" bg="url(/img/main.png) no-repeat" />
};

export default MainImage;
